<template>
  <Modal
    :id="'cmp-catalog-product_groups-product_export'"
    @cancelled="onCancel"
    :optionsJustify="'space-between'"
  >
    <template slot="header"
      >{{$t('product_report')}}</template
    >

    <template slot="body">
      <Dropdown
        :options="priceListTV"
        :selected="priceListTV.find(p => p.value == price_list_id)"
        :placeholder="$t('price_list')"
        deselect
        box
        @selectedChange="e => onDropdownChange('price_list_id', e)"
      ></Dropdown>
    
    </template>

    <template slot="options" class="progex">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        class="dt-button v1 s6"
        :disabled="exportDisabled"
        :class="{
          disabled: exportDisabled
        }"
        @click.stop="onExport"
      >
        {{$t('export')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { ProductGroupsService } from "../../services/product-groups.service";
import { async } from "rxjs/internal/scheduler/async";
import { createTV } from "../../../../models/text-value.model";
import fileDownload from "js-file-download";

export default {
  components: {
    Modal
  },
  data() {
    return {
      price_lists: [],
      price_list_id: "",

      priceListLoading: true
    };
  },
  mounted: async function() {
    this.priceListLoading = true;
    const res = await ProductGroupsService.fetchProductPriceList();
    this.price_lists = res.data.price_lists;
    this.priceListLoading = false;
  },
  computed: {
    product_group_id: function() {
      return this.$route.params.product_group_id;
    },
    priceListTV() {
      return createTV(this.price_lists, "price_list_name", "price_list_id");
    },
    exportDisabled() {
      return (
        this.priceListLoading ||
        !(this.price_list_id && this.price_list_id!="")
      );
    }
  },
  methods: {
    onExport: function() {
      ProductGroupsService.getExportProductReportExcel(
        this.product_group_id,
        this.price_list_id
      ).then(res => {
        fileDownload(res.data, "catalog_report.xlsx");
        this.onCancel();
      });
      // ContactIMEXService.getExportContactsExcel().then(res => {
      //   fileDownload(res.data, "contacts.xlsx");
      // })
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onDropdownChange(name, value) {
      
      this['price_list_id'] = value.value;
     // console.log(this.price_list_id,!(this.price_list_id && this.price_list_id!=""),'!(this.price_list_id && this.price_list_id=="")')
    }
  }
};
</script>

<style lang="scss">
.cmp-catalog-product_groups-product_export {
}
</style>
